<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2022-06-01 13:55:39
-->
<script>
export default {
    mounted(){
        this.$router.replace(this.$route.params.target);
    }
}
</script>